export default __webpack_public_path__ + "static/benchtop-79e66e38439e840f043e415aac73e5de.png";